import MidiEffect from './MidiEffect.js';
import MidiCCParameter from 'parameters/MidiCCParameter.js';
import {MOOG_MINITAUR} from 'constants/midi-cc-interfaces.js';

class MidiInterfaceEffect extends MidiEffect {
    constructor(track) {
        super('Midi Interface', track);
        this.ccParameters = [];
        this.midiOutput = undefined;
    }

    setConfig(midiOutput, config) {
        this.midiOutput = midiOutput;
        this.midiCC = this.track.sequencerEngine
            .midi.deviceToMidiCC[midiOutput.name];
        this.midiDeviceName = midiOutput.name;
        if (this.midiCC === undefined) {
            return;
        }

        // config is just a map from ccNumber => parameter name
        for (let i in config) {
            let sectionConfig = config[i];
            let sectionToAdd = {};
            for (let sectionName in sectionConfig) {
                let section = sectionConfig[sectionName];
                sectionToAdd[sectionName] = {};
                for (let parameterName in section) {
                    let ccNumber = section[parameterName];
                    let ccParameter = new MidiCCParameter(
                        parameterName,
                        ccNumber,
                        this.midiCC);
                    
                    this.registerParameter(ccParameter);
                    sectionToAdd[sectionName][parameterName] = ccParameter;
                }
            }

            this.ccParameters.push(sectionToAdd);
        }
    }

    getCopy(track, ignoreId=true) {
        let fx = new MidiInterfaceEffect(track);
        fx.fromJson(this.getJson(), ignoreId);
        return fx;
    }
    
    output(time, stepNumber, actualStepNumber) {
        return this.triggers;
    }

    getJson() {
        let json = super.getJson();

        json.midiOutput = this.midiOutput.name;

        let sections = [];
        for (let i in this.ccParameters) {
            let section = this.ccParameters[i];
            let sectionJson = {};

            for (let j in section) {
                let subsection = section[j];
                // subsection has multiple parameters well create a json for each subsection
                let subsectionJson = {};
                for (let k in subsection) {
                    let parameter = subsection[k];
                    subsectionJson[parameter.name] = 
                        parameter.getJson();
                }
                sectionJson[j] = subsectionJson;
            }

            sections.push(sectionJson);
        }

        json.config = sections;
        return json;
    }

    fromJson(json, isCopy) {
        super.fromJson(json, isCopy);

        let midi = this.track.sequencerEngine.midi;
        if (midi === undefined) {
            return;
        }
        let output = midi.controllerOutputs.filter(
            o => o.name === json.midiOutput)[0];

        if (output === undefined) {
            return;
        }

        this.midiOutput = output;
        this.track.addMidiOutput(output, true);
        this.midiCC = this.track.sequencerEngine
            .midi.deviceToMidiCC[output.name];

        for (let i in json.config) {
            let section = json.config[i];

            for (let name in section) {
                let subsection = section[name];
                for (let parameterName in subsection) {
                    let parameterJson = subsection[parameterName];
                    let parameter = new MidiCCParameter(
                        parameterName, parameterJson.ccNumber, this.midiCC);
                    parameter.fromJson(parameterJson, this.track.sequencerEngine);
                    this.registerParameter(parameter);
                    subsection[parameterName] = parameter;
                }
            }
        }

        this.ccParameters = json.config;
    }
}

export default MidiInterfaceEffect;
